import { render, staticRenderFns } from "./DormerMaterialRadioField.vue?vue&type=template&id=6dfa226e"
import script from "./DormerMaterialRadioField.vue?vue&type=script&lang=js"
export * from "./DormerMaterialRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports